
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'LoadingOverlay',
    props: {
        loading: Boolean
    }
})
